import React from 'react';
import PropTypes from 'prop-types';

import { NormalText } from '../StyledComponents';
import NoImage from '../NoImage';
import { getImageUrl } from '../../helpers/imageUrlHelpers';
import Image from '../Image';
import Link from '../Link';

import './ProductItem.module.scss';

class ProductItem extends React.PureComponent {
  renderImage() {
    const { isMobile, imageUrl, mobileImageUrl, name } = this.props;

    const imageSrc = getImageUrl(imageUrl, mobileImageUrl, isMobile);

    if (imageSrc) {
      return <Image styleName="image" src={imageSrc} name={name} />;
    }

    // sometimes desktop product item is too small to fit NoImage so we always pass isMobile=true
    return (
      <div styleName="no-image">
        <NoImage isMobile={true} />
      </div>
    );
  }

  render() {
    const {
      isMobile,
      name,
      price,
      link,
      designSettings: { bodyHeadingsColor, bodyTextColor, bodyFontSize, bodyFont },
    } = this.props;

    return (
      <div styleName="product">
        <div styleName="image-wrapper">
          <Link styleName="content" href={link}>
            {this.renderImage()}
          </Link>
        </div>
        <div styleName="name">
          <NormalText
            isMobile={isMobile}
            type="bodyPrimary"
            font={bodyFont}
            fontSize={bodyFontSize}
            color={bodyHeadingsColor}
          >
            {name}
          </NormalText>
        </div>
        <div styleName="price">
          <NormalText
            isMobile={isMobile}
            type="bodyPrimary"
            font={bodyFont}
            fontSize={bodyFontSize}
            color={bodyTextColor}
          >
            {price}
          </NormalText>
        </div>
      </div>
    );
  }
}

ProductItem.propTypes = {
  isMobile: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.string,
  link: PropTypes.string,
  imageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  designSettings: PropTypes.shape({
    bodyFont: PropTypes.string,
    bodyFontSize: PropTypes.string,
    bodyTextColor: PropTypes.string,
  }),
};

export default ProductItem;
